export default class Injures extends createjs.Bitmap{
   public paused:boolean;
   public removed:boolean;
   public width:number;
   public height:number;
   public type: string;
   public name: string;
   public place: string;
   public move_config:any;
   public in_stage:boolean;
   public id_key:number;
   public rotate:number;

   private error:string;

   constructor(img: HTMLImageElement) {
       super(img);
       this.paused = false;
       this.removed = false;
       this.move_config = null;
       this.in_stage = false;
       this.id_key = null;
	   this.cursor = "pointer";

	   if ( img === null ) {
		   this.error = "Image is null!";
		   console.error(this.error);
	       return;
	   }

	   if ( img.width === undefined ) {
		   this.error = "Cannot get imae width property!";
		    console.error(this.error);
	       return;
	   }
       this.width = img.width;
       this.height = img.height;
       this.scaleX = 0.6;
       this.scaleY = 0.6;
   }

   public getError():string{
	   return this.error;
   }

   public setAlpha(num:number):void{
	   this.alpha = num;
   }

   public setRotate(num:number):void{
	   this.rotation = num;
	   this.rotate = num;
   }
}



// WEBPACK FOOTER //
// ./components/family_tree/items/Injures.ts